import React, { useState, useEffect } from 'react';
import { View, TextInput, TouchableOpacity, Platform } from 'react-native';
import { homeStyles } from '../styles/HomeStyles';
import { useTheme } from '../contexts/ThemeContext';
import { transparentTextInputStyle } from '../utils/transparentTextInputStyle';

function setWebSearchInputStyles(inputId, textColor, placeholderColor) {
  if (Platform.OS !== 'web' || typeof document === 'undefined' || !inputId) return;
  const styleId = `vrc-search-styles-${inputId}`;
  let el = document.getElementById(styleId);
  if (!el) {
    el = document.createElement('style');
    el.id = styleId;
    document.head.appendChild(el);
  }
  el.textContent = `
    #${inputId} {
      color: ${textColor} !important;
      -webkit-text-fill-color: ${textColor} !important;
      caret-color: ${textColor} !important;
      background-color: transparent !important;
      background: transparent !important;
      -webkit-appearance: none;
      appearance: none;
      box-shadow: none !important;
    }
    #${inputId}::placeholder { color: ${placeholderColor} !important; opacity: 1 !important; }
    #${inputId}::-webkit-input-placeholder { color: ${placeholderColor} !important; opacity: 1 !important; }
    #${inputId}::-moz-placeholder { color: ${placeholderColor} !important; opacity: 1 !important; }
  `;
}

export function SearchBar({
  onSearch,
  value,
  onChangeText,
  onSubmit,
  placeholder,
  color = '#000000',
  nativeID = 'home-search-input',
  placeholderColor: placeholderColorProp,
}) {
  const [isFocused, setIsFocused] = useState(false);
  const { isDarkMode } = useTheme();

  const placeholderColor = placeholderColorProp
    ?? (isDarkMode ? 'rgba(255,255,255,0.55)' : 'rgba(0,0,0,0.65)');

  useEffect(() => {
    setWebSearchInputStyles(nativeID, color, placeholderColor);
  }, [nativeID, color, placeholderColor]);

  if (Platform.OS === 'web' && typeof document !== 'undefined') {
    setWebSearchInputStyles(nativeID, color, placeholderColor);
  }

  return (
    <View style={[homeStyles.searchContainer, { borderBottomColor: color, borderOpacity: 0.5, backgroundColor: 'transparent' }]}>
      <TextInput
        style={[homeStyles.searchInput, transparentTextInputStyle, { color }]}
        nativeID={nativeID}
        placeholder={isFocused ? '' : (placeholder || "Search for venues by name, city, state, affiliate...")}
        placeholderTextColor={placeholderColor}
        value={value}
        onChangeText={onChangeText}
        onSubmitEditing={onSubmit}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        returnKeyType="search"
        autoCorrect={false}
        autoCapitalize="none"
        accessibilityLabel="Search venues"
        accessibilityHint="Enter venue name, city, state, or affiliate"
      />
      {Platform.OS === 'web' && (
        <TouchableOpacity 
          style={homeStyles.searchIcon} 
          onPress={onSubmit}
          accessibilityLabel="Submit search"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z" fill={color}/>
          </svg>
        </TouchableOpacity>
      )}
    </View>
  );
}
